import { Component } from '@angular/core';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'cv-page-access-cell',
    templateUrl: './page-access-cell.component.html',
    styles: [
      
    ]
})
export class PageAccessCellRenderer implements ICellRendererAngularComp {

    public DisplayName: any;
    public Description: any;

    public disabledNone: boolean = false;
    public disabledView: boolean = false;
    public disabledEdit: boolean = false;
    public disabledCreate: boolean = false;
    public startingAccess: string = "";

    public localizationUsers: Map<string, string>;

    public noneHoverMessage: string = '';
    public viewHoverMessage: string = '';
    public editHoverMessage: string = '';
    public createHoverMessage: string = '';

    public loadAccessNone: boolean = false;
    public loadAccessRead: boolean;
    public loadAccessEdit: boolean;
    public loadAccessCreate: boolean;
    public parameters: ICellRendererParams;

    maxAccess: string = "0";  //0:none, 1:read, 2:write, 3:create
    public isChildPage: boolean;

    constructor(
      private cvLocalizationFactory: CVLocalizationService
    ) { }

    async agInit(params: ICellRendererParams) {
      this.localizationUsers = await this.cvLocalizationFactory.GetSection("Users");

      if(params.node.data != null){
        this.setValues(params);
      }
    }

    refresh(params: ICellRendererParams): boolean {
      return false;
    }

    /**
     * Returns localized string from the CXOne_Objectives localization section.
     * @param key Key for localized string to retrieve
     * @param defaultValue Value to return if error occurs
     * @param inserts Values to insert into the localized (or default) string; the first will replace {0}, the second will replace {1}, etc.
     */
    public getLocalizedString(key: string, defaultValue: string, ...inserts: string[]) {
        let baseString = this.cvLocalizationFactory.getCachedText("Users", key, defaultValue);

        for (let i = 0; i < inserts.length; i++) {
            baseString = baseString.replace(`{${i}}`, inserts[i]);
        }

        return baseString;
    }

    public setValues(params: ICellRendererParams) {
        this.parameters = params;
        this.loadAccessNone = true;
        this.loadAccessRead = params.node.data.AccessReadAvailable;
        this.loadAccessEdit = params.node.data.AccessWriteAvailable;
        this.loadAccessCreate = params.node.data.AccessCreateAvailable;

        if(this.parameters.node.data.IsChildPage){
          this.isChildPage = true;
        }

        this.DisplayName = this.parameters.data.DisplayName;
        this.Description = this.parameters.data.Description;

        this.parameters.node.data.DisplayName = this.DisplayName;
        this.parameters.node.data.Description = this.Description;

        this.setAccess();
    }

    public setAccess(){
      //Here I have to check a bunch of things to make sure that certain radio buttons are set to disabled and they are getting the right hover message
      let data = this.parameters.node.data;

      if (data.AccessCreateAvailable) {
        if(data.CreateAvailable && data.RoleCreateAvailable){
          this.maxAccess = "3";
          this.startingAccess = "3";

          this.disabledNone = true;
          this.disabledView = true;
          this.disabledEdit = true;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
          this.viewHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
          this.editHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.CreateAvailable && data.RoleWriteAvailable){
          this.maxAccess = "3";
          this.startingAccess = "2";

          this.disabledNone = true;
          this.disabledView = true;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
          this.viewHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.CreateAvailable && data.RoleReadAvailable){
          this.maxAccess = "3";
          this.startingAccess = "1";

          this.disabledNone = true;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.CreateAvailable && !data.RoleReadAvailable && !data.RoleWriteAvailable && !data.RoleCreateAvailable){
          this.maxAccess = "3";
          this.startingAccess = "0";

          this.disabledNone = false;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;
        }
        else if(data.WriteAvailable && data.RoleWriteAvailable && !data.RoleCreateAvailable){
          this.maxAccess = "2";
          this.startingAccess = "2";

          this.disabledNone = true;
          this.disabledView = true;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
          this.viewHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.WriteAvailable && data.RoleReadAvailable && !data.RoleWriteAvailable && !data.RoleCreateAvailable){
          this.maxAccess = "2";
          this.startingAccess = "1";

          this.disabledNone = true;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.WriteAvailable && !data.RoleReadAvailable && !data.RoleWriteAvailable && !data.RoleCreateAvailable){
          this.maxAccess = "2";
          this.startingAccess = "0";

          this.disabledNone = false;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;
        }
        else if(data.ReadAvailable && data.RoleReadAvailable && !data.RoleWriteAvailable && !data.RoleCreateAvailable){
          this.maxAccess = "1";
          this.startingAccess = "1";

          this.disabledNone = true;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.ReadAvailable && !data.RoleReadAvailable && !data.RoleWriteAvailable && !data.RoleCreateAvailable){
          this.maxAccess = "1";
          this.startingAccess = "0";

          this.disabledNone = false;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;
        }
        else if(data.RoleCreateAvailable){
          this.maxAccess = "3";
          this.startingAccess = "3";

          this.disabledNone = true;
          this.disabledView = true;
          this.disabledEdit = true;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
          this.viewHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
          this.editHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.RoleWriteAvailable){
          this.maxAccess = "2";
          this.startingAccess = "2";

          this.disabledNone = true;
          this.disabledView = true;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
          this.viewHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.RoleReadAvailable){
          this.maxAccess = "1";
          this.startingAccess = "1";

          this.disabledNone = true;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else{
          this.startingAccess = "0";
        }
      }
      else if (data.AccessWriteAvailable) {
        if(data.WriteAvailable && data.RoleWriteAvailable){
          this.maxAccess = "2";
          this.startingAccess = "2";

          this.disabledNone = true;
          this.disabledView = true;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
          this.viewHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.WriteAvailable && data.RoleReadAvailable){
          this.maxAccess = "2";
          this.startingAccess = "1";

          this.disabledNone = true;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.WriteAvailable && !data.RoleReadAvailable && !data.RoleWriteAvailable && !data.RoleCreateAvailable){
          this.maxAccess = "2";
          this.startingAccess = "0";

          this.disabledNone = false;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;
        }
        else if(data.ReadAvailable && data.RoleReadAvailable && !data.RoleWriteAvailable && !data.RoleCreateAvailable){
          this.maxAccess = "1";
          this.startingAccess = "1";

          this.disabledNone = true;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.ReadAvailable && !data.RoleReadAvailable && !data.RoleWriteAvailable){
          this.maxAccess = "1";
          this.startingAccess = "0";

          this.disabledNone = false;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;
        }
        else if(data.RoleWriteAvailable){
          this.maxAccess = "2";
          this.startingAccess = "2";

          this.disabledNone = true;
          this.disabledView = true;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
          this.viewHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.RoleReadAvailable){
          this.maxAccess = "1";
          this.startingAccess = "1";

          this.disabledNone = true;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else{
          this.startingAccess = "0";
        }
      }
      else if (data.AccessReadAvailable) {
        if(data.ReadAvailable && data.RoleReadAvailable){
          this.maxAccess = "1";
          this.startingAccess = "1";

          this.disabledNone = true;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else if(data.ReadAvailable && !data.RoleReadAvailable && !data.RoleWriteAvailable){
          this.maxAccess = "1";
          this.startingAccess = "0";

          this.disabledNone = false;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;
        }
        else if(data.RoleReadAvailable){
          this.maxAccess = "1";
          this.startingAccess = "1";

          this.disabledNone = true;
          this.disabledView = false;
          this.disabledEdit = false;
          this.disabledCreate = false;

          this.noneHoverMessage = this.getLocalizedString("Role_Default",'Access can only be increased from Role default');
        }
        else{
          this.startingAccess = "0";
        }
      }
      else{

      }

      if(!this.parameters.context.editMode){
        this.disabledNone = true;
        this.disabledView = true;
        this.disabledEdit = true;
        this.disabledCreate = true;
        
        this.noneHoverMessage = this.getLocalizedString("Pencil_Icon_Message", 'Click on the pencil icon to edit access.');
        this.viewHoverMessage = this.getLocalizedString("Pencil_Icon_Message", 'Click on the pencil icon to edit access.');
        this.editHoverMessage = this.getLocalizedString("Pencil_Icon_Message", 'Click on the pencil icon to edit access.');
        this.createHoverMessage = this.getLocalizedString("Pencil_Icon_Message", 'Click on the pencil icon to edit access.');
      }
    }

    public updateValues() {
        //Here I check to see if they previously had access and if they didn't then I set a flag variable hasPreviousLoginPageAccess
        if(!this.parameters.node.data.ReadAvailable && !this.parameters.node.data.WriteAvailable && !this.parameters.node.data.CreateAvailable){
          this.parameters.node.data.hasPreviousLoginPageAccess = false;
        }
        else{
          this.parameters.node.data.hasPreviousLoginPageAccess = true;
        }

        if(this.maxAccess == "3") {
              this.parameters.node.data.ReadAvailable = true;
              this.parameters.node.data.WriteAvailable = true;
              this.parameters.node.data.CreateAvailable = true;
              this.parameters.node.data.isChanged = true;
              
              if(this.startingAccess == "0"){
                this.parameters.node.data.pageByProfile = false;
              }
              else{
                this.parameters.node.data.pageByProfile = true;
              }

              if(!this.parameters.node.data.hasPreviousLoginPageAccess){
                this.parameters.node.data.pageByProfile = false;
              }
              else{
                this.parameters.node.data.pageByProfile = true;
              }
        }
        else if (this.maxAccess == "2") {
              this.parameters.node.data.ReadAvailable = true;
              this.parameters.node.data.WriteAvailable = true;
              this.parameters.node.data.CreateAvailable = false;
              this.parameters.node.data.isChanged = true;

              if(this.startingAccess == "0"){
                this.parameters.node.data.pageByProfile = false;
              }
              else{
                this.parameters.node.data.pageByProfile = true;
              }

              if(!this.parameters.node.data.hasPreviousLoginPageAccess){
                this.parameters.node.data.pageByProfile = false;
              }
              else{
                this.parameters.node.data.pageByProfile = true;
              }
        }
        else if (this.maxAccess == "1") {
              this.parameters.node.data.ReadAvailable = true;
              this.parameters.node.data.WriteAvailable = false;
              this.parameters.node.data.CreateAvailable = false;
              this.parameters.node.data.isChanged = true;

              if(this.startingAccess == "0"){
                this.parameters.node.data.pageByProfile = false;
              }
              else{
                this.parameters.node.data.pageByProfile = true;
              }

              if(!this.parameters.node.data.hasPreviousLoginPageAccess){
                this.parameters.node.data.pageByProfile = false;
              }
              else{
                this.parameters.node.data.pageByProfile = true;
              }
        }
        else {
              this.parameters.node.data.ReadAvailable = false;
              this.parameters.node.data.WriteAvailable = false;
              this.parameters.node.data.CreateAvailable = false;
              this.parameters.node.data.isChanged = true;
              //I don't know why this has to be enabled but to remove this from the db it has to be marked as true
              this.parameters.node.data.pageByProfile = true;
        }

        //I have to call redrawRows cause it sets all of them if I don't reset the rows after.
        this.parameters.context.enableChanges();
        this.parameters.api.redrawRows();
    }
}
